(function () {
  'use strict';

  /* ---- Mobile nav drawer ---- */
  function initMobileNav() {
    var nav     = document.getElementById('mobile-nav');
    var openBtn = document.getElementById('nav-open');
    var closeBtn = document.getElementById('nav-close');
    var overlay  = nav ? nav.querySelector('.mobile-nav__overlay') : null;

    if (!nav || !openBtn) return;

    function openDrawer() {
      nav.classList.add('is-open');
      nav.removeAttribute('aria-hidden');
      document.body.classList.add('drawer-open');
      document.documentElement.classList.add('drawer-open');
      document.body.style.overflow = 'hidden';
      openBtn.setAttribute('aria-expanded', 'true');
    }

    function closeDrawer() {
      nav.classList.remove('is-open');
      nav.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('drawer-open');
      document.documentElement.classList.remove('drawer-open');
      document.body.style.overflow = '';
      openBtn.setAttribute('aria-expanded', 'false');
    }

    openBtn.addEventListener('click', openDrawer);
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    if (overlay)  overlay.addEventListener('click', closeDrawer);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && nav.classList.contains('is-open')) closeDrawer();
    });
  }

  /* ---- Sticky / auto-hide header on scroll ---- */
  function initStickyHeader() {
    var header = document.querySelector('.site-header');
    if (!header) return;

    var annBar    = document.querySelector('.announcement-bar');
    var threshold = annBar ? annBar.offsetHeight + 10 : 10;
    var lastScrollY = window.scrollY;
    var isScrolled = header.classList.contains('is-scrolled');

    function isIpadWidth() {
      return window.matchMedia('(max-width: 1024px) and (min-width: 981px)').matches;
    }

    window.addEventListener('scroll', function () {
      var currentScrollY = window.scrollY;

      if (isIpadWidth()) {
        if (!isScrolled && currentScrollY > threshold + 12) {
          isScrolled = true;
          header.classList.add('is-scrolled');
        } else if (isScrolled && currentScrollY < threshold - 8) {
          isScrolled = false;
          header.classList.remove('is-scrolled');
        }
      } else {
        header.classList.toggle('is-scrolled', currentScrollY > threshold);
        isScrolled = header.classList.contains('is-scrolled');
      }

      /* Keep header visible when sticky is enabled on mobile */
      if (document.body.classList.contains('sticky-header-disabled')) {
        var mobileNav = document.getElementById('mobile-nav');
        var navOpen = mobileNav && mobileNav.classList.contains('is-open');
        var popupOpen = document.body.classList.contains('variant-popup-open') || document.body.classList.contains('drawer-open');

        if (!navOpen && !popupOpen) {
          if (currentScrollY > lastScrollY && currentScrollY > 60) {
            header.classList.add('is-hidden');
          } else if (currentScrollY < lastScrollY) {
            header.classList.remove('is-hidden');
          }
        } else {
          header.classList.remove('is-hidden');
        }
      } else {
        header.classList.remove('is-hidden');
      }

      lastScrollY = Math.max(0, currentScrollY);
    }, { passive: true });
  }

  /* ---- Mega menu hover & touch tap state ---- */
  function initMegaMenu() {
    var header = document.querySelector('.site-header');
    if (!header) return;

    var megaItems = header.querySelectorAll('.site-nav__item--has-megamenu');
    if (!megaItems.length) return;

    megaItems.forEach(function (item) {
      item.addEventListener('mouseenter', function () {
        if (!('ontouchstart' in window || navigator.maxTouchPoints > 0)) {
          header.classList.add('is-megamenu-open');
          item.classList.add('is-open');
        }
      });

      item.addEventListener('mouseleave', function () {
        if (!('ontouchstart' in window || navigator.maxTouchPoints > 0)) {
          header.classList.remove('is-megamenu-open');
          item.classList.remove('is-open');
        }
      });

      var link = item.querySelector('.site-nav__link');
      if (link) {
        link.addEventListener('click', function (e) {
          var isTouchDevice = ('ontouchstart' in window) || (navigator.maxTouchPoints > 0) || window.innerWidth <= 1024;
          if (isTouchDevice) {
            e.preventDefault();
            e.stopPropagation();

            var isOpen = item.classList.contains('is-open') && header.classList.contains('is-megamenu-open');

            megaItems.forEach(function (other) {
              if (other !== item) other.classList.remove('is-open');
            });

            if (isOpen) {
              item.classList.remove('is-open');
              header.classList.remove('is-megamenu-open');
            } else {
              item.classList.add('is-open');
              header.classList.add('is-megamenu-open');
            }
          }
        });
      }
    });

    document.addEventListener('click', function (e) {
      if (!e.target.closest('.site-header')) {
        megaItems.forEach(function (item) {
          item.classList.remove('is-open');
        });
        header.classList.remove('is-megamenu-open');
      }
    });
  }

  /* ---- Cart badge + add-to-cart success notice ---- */
  function initCartNotice() {
    var notice = document.querySelector('.cart-added-notice');
    var closeBtn = notice ? notice.querySelector('.cart-added-notice__close') : null;
    var hideTimer = null;

    function formatCount(count) {
      var n = parseInt(count, 10) || 0;
      return n > 0 ? '+' + n : '';
    }

    function updateBadge(count) {
      var n = parseInt(count, 10) || 0;
      document.querySelectorAll('.header-action-btn__badge').forEach(function (badge) {
        badge.textContent = formatCount(n);
        badge.style.display = n > 0 ? '' : 'none';
      });

      document.querySelectorAll('.header-action-btn--cart, a[aria-label^="Cart"]').forEach(function (link) {
        link.setAttribute('aria-label', 'Cart (' + n + ' items)');
      });
    }

    function hideNotice() {
      if (!notice) return;
      notice.classList.remove('is-visible');
      notice.setAttribute('aria-hidden', 'true');
      notice.setAttribute('hidden', '');
    }

    function showNotice() {
      if (!notice) return;
      notice.removeAttribute('hidden');
      notice.setAttribute('aria-hidden', 'false');
      /* Force reflow so the enter transition always plays. */
      void notice.offsetWidth;
      notice.classList.add('is-visible');
      clearTimeout(hideTimer);
      hideTimer = setTimeout(hideNotice, 3200);
    }

    function refreshFromCart(options) {
      var opts = options || {};
      return fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          updateBadge(cart.item_count);
          if (opts.showNotice) showNotice();
          return cart;
        })
        .catch(function () {});
    }

    if (closeBtn) {
      closeBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        clearTimeout(hideTimer);
        hideNotice();
      });
    }

    window.BohopanaCart = {
      formatCount: formatCount,
      updateBadge: updateBadge,
      showNotice: showNotice,
      hideNotice: hideNotice,
      refreshFromCart: refreshFromCart
    };
  }

  document.addEventListener('DOMContentLoaded', function () {
    initMobileNav();
    initStickyHeader();
    initMegaMenu();
    initCartNotice();
  });
})();
